import { Switch, styled } from "@material-ui/core";

export const timeFormatter = (number: number) => {
  const sec = Math.floor(number / 1000);
  const min = Math.floor(sec / 60);
  const formatSec = sec % 60;
  const formatMin = String(min).padStart(2, "0");
  const tostr = String(formatSec).padStart(2, "0");
  return `${formatMin}:${tostr}`;
}
export const CustomSwitch = styled(Switch)(({ theme }) => ({
    width: 30,
    height: 18,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
              border: '1px solid #878787777',
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor:'#1890ff',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 30%)',
      width: 14,
      height: 14,
      borderRadius: 50,
      border: '1px solid #878787777',
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:'rgba(255,255,255,.35)' ,
      boxSizing: 'border-box',
      border: '1px solid #87878751'
    },
  }));